import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/ui/Form';
import './NotFoundPage.css';

export default function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="auth-notfound">
      <p className="auth-notfound__code">404</p>
      <p className="auth-notfound__text">{t('general.notFound')}</p>
      <div className="auth-notfound__action">
        <Button type="button" onClick={() => navigate('/')} withArrow>
          {t('general.backToLogin')}
        </Button>
      </div>
    </div>
  );
}
